// Default error message
const DEFAULT_ERROR_MSG = "Something went wrong !!!";
const WEGLOT_KEY = "wg_df2c9ca7e45e7670a9fdca739b010e1a1";
const DEFAULT_LANGUAGE = "en";
export { DEFAULT_ERROR_MSG, WEGLOT_KEY,DEFAULT_LANGUAGE};
